var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
const Progress = (_a, ref) => {
    var { className, percent = 0, showInfo = false, borderRadius = 0, fontSize = 16, strokeWidth = 6, color = '#09BB07', activeColor = '#09BB07', backgroundColor = '#EBEBEB', active = false, activeMode = 'backwards', duration = 30 } = _a, rest = __rest(_a, ["className", "percent", "showInfo", "borderRadius", "fontSize", "strokeWidth", "color", "activeColor", "backgroundColor", "active", "activeMode", "duration"]);
    const props = useTaroBaseEvents(rest);
    const prePercent = useRef(percent);
    const num = percent > 100
        ? 100
        : percent < 0
            ? 0
            : percent;
    const animationStyle = active
        ? {
            transitionProperty: 'transform',
            transitionDuration: activeMode === 'forwards'
                ? `${(num / 1e3) * (duration - prePercent.current)}s`
                : `${(num / 1e3) * duration}s`
        }
        : {};
    return (_jsxs("div", Object.assign({ ref: ref, className: classNames('weui-progress', className) }, props, { children: [_jsx("div", Object.assign({ className: 'weui-progress__bar', style: {
                    height: typeof strokeWidth === 'number' ? `${strokeWidth}px` : strokeWidth,
                    borderRadius: borderRadius ? `${borderRadius}px` : undefined,
                    backgroundColor
                } }, { children: _jsx("div", { className: 'weui-progress__inner-bar', style: Object.assign({ transform: `scaleX(${num}%)`, backgroundColor: activeColor }, animationStyle) }) })), showInfo && (_jsxs("span", Object.assign({ className: 'weui-progress__opr', style: {
                    fontSize: typeof fontSize === 'number' ? `${fontSize}px` : fontSize
                } }, { children: [num, "%"] })))] })));
};
export default forwardRef(Progress);
